module.exports = __webpack_public_path__ + "static/the-big-book-of-endurance-training-and-racing-14e3530520e6efbae49d8168a0f167e5.jpg";